import { useState } from "react";
import axios from "axios";
import { ReservationThreadData, MessageData } from "../types/reservation";
import { refreshToken as refreshAuthToken } from "../services/authServices"; // Import your refreshToken function

export const useSendMessage = (
  threadUid: string | undefined,
  setThreads: React.Dispatch<React.SetStateAction<ReservationThreadData[]>>
) => {
  const [sendMessageError, setSendMessageError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const sendMessage = async (
    newMessage: string,
    apiUrl: string,
    updateReservation: () => Promise<void>
  ) => {
    setLoading(true);
    try {
      let token = localStorage.getItem("token");
      if (!token) throw new Error("JWT Token not found");

      const response = await axios.post(
        apiUrl,
        {
          body: newMessage,
          types: ["whatsapp"],
          imageMediaUid: "",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const createdMessage: MessageData = response.data;

      setThreads((prevThreads) =>
        prevThreads.map((thread) =>
          thread.uid === threadUid
            ? { ...thread, messages: [...thread.messages, createdMessage] }
            : thread
        )
      );
      setLoading(false);
      await updateReservation();
    } catch (error: any) {
      console.error("Error sending message:", error);

      // Check if the error is due to expired token
      if (
        error.response?.status === 401 &&
        error.response.data.error === "ExpiredToken"
      ) {
        try {
          // Attempt to refresh the token using the refreshToken function from authServices
          await refreshAuthToken();

          // Retry the original request with the new token
          const newToken = localStorage.getItem("token");
          if (!newToken) throw new Error("JWT Token not found after refresh");

          const retryResponse = await axios.post(
            apiUrl,
            {
              body: newMessage,
              types: ["whatsapp"],
              imageMediaUid: "",
            },
            {
              headers: { Authorization: `Bearer ${newToken}` },
            }
          );

          const createdMessage: MessageData = retryResponse.data;

          setThreads((prevThreads) =>
            prevThreads.map((thread) =>
              thread.uid === threadUid
                ? { ...thread, messages: [...thread.messages, createdMessage] }
                : thread
            )
          );
          setLoading(false);
          await updateReservation();
        } catch (refreshError) {
          console.error("Token refresh failed:", refreshError);
          setSendMessageError("Session expired. Please log in again.");
        }
      } else {
        setSendMessageError("Error sending message. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { sendMessage, sendMessageError, loading, setLoading };
};
